export default { sha: '2391c920ff41caf881e38e1fe7f9acf67e73700f', buildNumber: 'undefined' }
